// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlobalInput_label__FRge7 {
  display: block;
  margin-bottom: 8px;
  color: var(--heading-color);
  font-size: 16px;
}

.GlobalInput_input__VKxP7 {
  display: block;
  width: 329px;
  max-width: 100%;

  box-sizing: border-box;
  height: 40px;
  padding: 10px 16px;
  border: 1px solid var(--light-grey-color);
  border-radius: 8px;
  color: var(--heading-color);
  background-color: var(--color-white,);
  font: inherit;
  opacity: 1;
  outline: none;
  transition: border-color 150ms ease;
}

.GlobalInput_input--large__BE9G3 {
  height: var(--input-large-height);
  font-size: 16px;
}

.GlobalInput_input--small__RkxxE {
  height: var(--input-small-height);
  font-size: 14px;
}

.GlobalInput_input__VKxP7:hover,
.GlobalInput_input__VKxP7:focus {
  border-color: var(--primary-color);
}

.GlobalInput_input__VKxP7:disabled {
  background-color: var(--disabled-color);
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/shared/utils/GlobalInput.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;;EAEf,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,aAAa;EACb,UAAU;EACV,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB","sourcesContent":[".label {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--heading-color);\n  font-size: 16px;\n}\n\n.input {\n  display: block;\n  width: 329px;\n  max-width: 100%;\n\n  box-sizing: border-box;\n  height: 40px;\n  padding: 10px 16px;\n  border: 1px solid var(--light-grey-color);\n  border-radius: 8px;\n  color: var(--heading-color);\n  background-color: var(--color-white,);\n  font: inherit;\n  opacity: 1;\n  outline: none;\n  transition: border-color 150ms ease;\n}\n\n.input--large {\n  height: var(--input-large-height);\n  font-size: 16px;\n}\n\n.input--small {\n  height: var(--input-small-height);\n  font-size: 14px;\n}\n\n.input:hover,\n.input:focus {\n  border-color: var(--primary-color);\n}\n\n.input:disabled {\n  background-color: var(--disabled-color);\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `GlobalInput_label__FRge7`,
	"input": `GlobalInput_input__VKxP7`,
	"input--large": `GlobalInput_input--large__BE9G3`,
	"input--small": `GlobalInput_input--small__RkxxE`
};
export default ___CSS_LOADER_EXPORT___;
